import { BookedInsuranceLineListCriteria, CustomInsuranceBookedListCriteria, CustomInsuranceExportRunListCriteria } from "../objects/customInsuranceBookedTypeList";

/** TripHistory actions 110-114. */
export const AUDIT_ACTION_OPTIONS: { value: number, label: string }[] = [
    { value: 110, label: 'insurance.audit-action-price-override' },
    { value: 111, label: 'insurance.audit-action-off-catalog-add' },
    { value: 112, label: 'insurance.audit-action-margin-change' },
    { value: 113, label: 'insurance.audit-action-auto-recalc' },
    { value: 114, label: 'insurance.audit-action-refused' },
];

export const EMPTY_CUSTOM_INSURANCE_BOOKED_LIST_CRITERIA: CustomInsuranceBookedListCriteria = {
    limit: 50,
    page: 0,
    action: '',
    trip: '',
};

export const EMPTY_BOOKED_INSURANCE_LINE_LIST_CRITERIA: BookedInsuranceLineListCriteria = {
    limit: 25,
    page: 0,
    trip: '',
    custom_insurance: null,
};

export const EMPTY_CUSTOM_INSURANCE_EXPORT_RUN_LIST_CRITERIA: CustomInsuranceExportRunListCriteria = {
    limit: 25,
    page: 0,
};
